import { DARK_THEME_COLORS, LIGHT_THEME_COLORS } from '@webtrader/core/themes/colors';

export const rgba = (rgb: string | undefined, opacity: number) => {
  if (!rgb) {
    return '';
  }

  return rgb.replace('rgb', 'rgba').replace(')', `, ${opacity})`);
};

export const hexToRgb = (hex: string, opacity?: number) => {
  const result = /^#?([a-f\d]{2})([a-f\d]{2})([a-f\d]{2})$/i.exec(hex);

  if (result) {
    const r = parseInt(result[1], 16);
    const g = parseInt(result[2], 16);
    const b = parseInt(result[3], 16);

    if (opacity !== undefined) {
      return `rgba(${r}, ${g}, ${b}, ${opacity})`;
    }

    return `rgb(${r}, ${g}, ${b})`;
  }

  return null;
};

export const mapSchemeToColors = () => {
  if (window.matchMedia && window.matchMedia('(prefers-color-scheme: dark)').matches) {
    return DARK_THEME_COLORS;
  }

  return LIGHT_THEME_COLORS;
};
